const key = process.env.NODE_ENV === 'development' ? '2234' : 'preview'
const isPreview = window.location.origin.includes(key)

export {
    isPreview,
}
